<style scoped>
    .transform-skewX-_45{
        transform: skewX(-45deg);
    }
    .transform-skewX-45{
        transform: skewX(45deg);
    }
    .mx-_4rem{
        margin-left: -.4rem;
        margin-right: -.4rem;
    }
    .bi-x-lg::before,.bi-check::before{
        font-weight: bold !important;
    }
    .border-start-transparent{
        border-left-color: transparent !important;
    }
    .border-bottom-transparent{
        border-bottom-color: transparent !important;
    }
    .top--_4rem{
        top: -.4rem;
    }
    .start--_15rem{
        left: -.15rem;
    }
    .camp-hover-scale.opacity-50:hover{
        scale: 1.1;
        z-index: 1;
        transition: scale .5s cubic-bezier(.25, 1.15, .35, 3.08);
        box-shadow: 0 0 .5rem #000;
    }
    .camp-hover-scale::after{
        content: '';
        position: absolute;
        top:0;
        bottom:0;
        left: 0;
        right: 0;
        background: linear-gradient(180deg,rgba(255,255,255,.3),transparent);
    }
    .btn-number-green{
        background:  linear-gradient(to top, rgba(0, 0, 0, .2), rgba(255, 255, 255, .2));
        box-shadow: .15rem .15rem 0 #005f24, .15rem .15rem .1rem .02rem #000, inset 0 0 .3rem rgba(252, 252, 252, 0.6);
    }
    .btn-number-red{
        background:  linear-gradient(to top, rgba(0, 0, 0, .2), rgba(255, 255, 255, .2));
        box-shadow: .15rem .15rem 0 #bb1828, .15rem .15rem .1rem .02rem #000, inset 0 0 .3rem rgba(252, 252, 252, 0.6);
    }
    .btn-number-blue{
        background:  linear-gradient(to top, rgba(0, 0, 0, .2), rgba(255, 255, 255, .2));
        box-shadow: .15rem .15rem 0 #0b57c7, .15rem .15rem .1rem .02rem #000, inset 0 0 .3rem rgba(252, 252, 252, 0.6);
    }
    .btn-number-red[role='button']:hover,.btn-number-blue:hover,.btn-number-green:hover{
        background:  linear-gradient(to top, rgba(0, 0, 0, .2), rgba(255, 255, 255, .2) 70%);
    }
    .btn-number-red[role='button']:active,.btn-number-blue:active,.btn-number-green:active{
        box-shadow: inset .1rem .1rem 0 #000, inset 0 0 .3rem rgba(252, 252, 252, 0.6);
    }
    .translate-0{
        transform: translate(0);
    }
    .hover-highlight:hover{
        background-image:  linear-gradient(to right, rgba(255, 255, 255, .1), rgba(255, 255, 255, .1));
    }
    .transition-transform{
        transition: transform .25s ease;
    }
    .translate-end{
        transform: translateX(-113%);
    }
</style>
<template>
    <div class="d-flex flex-column flex-sm-row h-100">
        <!-- 横向导航 -->
        <navbar class="order-first d-flex flex-column d-sm-none" :has-chat-msg="hasChatMsg" :is-page-ready="isPageReady" :is-fullscreen="isFullscreen" ></navbar>
        <!-- 纵向导航 -->
        <navbar-vertical class="d-none d-sm-flex" :is-fullscreen="isFullscreen"></navbar-vertical>
        <!-- 主体内容 -->
        <div class="d-flex flex-grow-1 h-xs-0 flex-column position-xs-relative start-0 end-0 top-0 translate-0 overflow-hidden">
            <!-- 当前进程 -->
            <div class="order-sm-2 d-flex fw-bold text-center small mx-_4rem text-nowrap">
                <div v-for="(item,i) in matchInfo.progress" :key="item" :class="{'me-1':i!=matchInfo.progress.length-1,'text-opacity-50':item<matchInfo.currProg}" class="col d-flex flex-column position-relative text-light">
                    <div :class="{'bg-opacity-50':item<matchInfo.currProg,'bg-secondary':item>matchInfo.currProg,'bg-success':item<=matchInfo.currProg}" class="position-absolute start-0 top-0 w-100 h-50 transform-skewX-45"></div>
                    <div :class="{'bg-opacity-50':item<matchInfo.currProg,'bg-secondary':item>matchInfo.currProg,'bg-success':item<=matchInfo.currProg}" class="position-absolute start-0 bottom-0 w-100 h-50 transform-skewX-_45 mb-_01rem"></div>
                    <span class="position-relative">{{MATCH_PROG_STATE[item]}}</span>
                </div>
            </div>
            <!-- 视频 -->
            <div class="order-sm-1 d-flex flex-column position-relative">
                <!-- 公告 -->
                <notice class="d-none d-sm-flex position-absolute"></notice>
                <!-- 视频 -->
                <div class="d-flex flex-grow-1 index-1">
                    <div class="col">
                        <div class="pt-60 h-0 position-relative">
                            <media-video id="video1" class="position-absolute top-0 start-0 bg-transparent img-sm-thumbnail" :video-index="0" :video-list="videoList" :countdown="roomInfo.countdown" :room-class="['top-sm-0 mt-2 mt-sm-5 ms-1 ms-sm-2 index-12']" :time-class="['top-0 mt-2 mt-sm-5 ms-2']" :img-class="['position-absolute translate-middle top-50 start-50 w-100 h-sm-100']"></media-video>
                        </div>
                    </div>
                    <div class="col d-none d-sm-block">
                        <div class="pt-60 h-0 position-relative">
                            <media-video id="video2" class="position-absolute top-0 start-0 d-none d-sm-block bg-transparent img-sm-thumbnail" :video-index="1" :video-list="videoList" :countdown="roomInfo.countdown" :room-class="['d-none']" :time-class="['d-none']" :img-class="['position-absolute translate-middle top-50 start-50 w-100 h-sm-100 bg-transparent']"></media-video>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 数据比较区 -->
            <div class="d-flex d-sm-none flex-column p-2 flex-grow-1 h-0 overflow-y-scroll scroll-none position-relative" style="background: linear-gradient(90deg,var(--bs-danger),var(--bs-primary));">
                <!-- 选手信息 -->
                <div class="d-flex mb-2">
                    <!-- 红方 -->
                    <div class="col d-flex justify-content-between align-items-center pe-3 rounded-pill me-2" style="box-shadow: 0 0 .3rem #000;">
                        <!-- 头像 -->
                        <div class="rounded-circle overflow-hidden border border-danger border-2 w-3rem h-3rem">
                            <img class="w-100 h-100" :src="getPhotoByCamp(0)" @error="getDefaultImg(1,$event)" alt="">
                        </div>
                        <!-- 基础信息 -->
                        <span class="fw-bold text-danger text-shadow-white">{{$root.getCampByIndex([matchInfo],matchInfo.tableid,0).name}}</span>
                    </div>
                    <!-- 蓝方 -->
                    <div class="col d-flex justify-content-between align-items-center ps-3 rounded-pill ms-2" style="box-shadow: 0 0 .3rem #000;">
                        <!-- 基础信息 -->
                        <span class="fw-bold text-primary text-shadow-white">{{$root.getCampByIndex([matchInfo],matchInfo.tableid,1).name}}</span>
                        <!-- 头像 -->
                        <div class="rounded-circle overflow-hidden border border-primary border-2 w-3rem h-3rem">
                            <img class="w-100 h-100" :src="getPhotoByCamp(1)" @error="getDefaultImg(2,$event)" alt="">
                        </div>
                    </div>
                </div>
                <!-- 第n条属性 -->
                <div v-for="(val,key) in $root.getCampByIndex([matchInfo],matchInfo.tableid,0).attr" :key="key" class="d-flex flex-column bg-black rounded px-2 pb-2 pt-1 mb-2">
                    <!-- 数据键值 -->
                    <div class="d-flex text-light fs-_8rem">
                        <span class="col">{{val}}</span>
                        <span>{{key}}</span>
                        <span class="col text-end">{{$root.getCampByIndex([matchInfo],matchInfo.tableid,1).attr[key]}}</span>
                    </div>
                    <!-- 数据图形 -->
                    <div class="rounded overflow-hidden d-flex h-_5rem">
                        <span class="bg-danger progress-bar progress-bar-striped progress-bar-striped-right progress-bar-animated" :style="{width: (isNaN(val)?50:val/$np.plus(val,$root.getCampByIndex([matchInfo],matchInfo.tableid,1).attr[key])*100)+'%'}"></span>
                        <span class="bg-primary progress-bar progress-bar-striped progress-bar-animated flex-grow-1"></span>
                    </div>
                </div>
            </div>
            <!-- 竞猜区 -->
            <div class="flex-sm-grow-1 order-sm-3 d-flex flex-column flex-sm-row">
                <!-- PC版红方信息 -->
                <div class="d-none d-sm-flex col-2 p-2">
                    <div class="flex-grow-1 rounded-3 d-flex flex-column p-2 bg-danger bg-opacity-50 bg-gradient">
                        <!-- 头像 -->
                        <div class="d-flex align-items-center pb-2 position-relative">
                            <div class="rounded-circle overflow-hidden border border-danger border-2 w-3rem h-3rem">
                                <img class="w-100 h-100" :src="getPhotoByCamp(0)" @error="getDefaultImg(1,$event)" alt="">
                            </div>
                            <span class="text-danger text-shadow-white fw-bold ms-2">{{$root.getCampByIndex([matchInfo],matchInfo.tableid,0).name}}</span>
                            <img v-if="matchInfo.result==1" class="position-absolute top-50 start-50 ms-3 translate-middle-y w-7rem index-1" src="@/assets/images/room/guess/win_1.png" alt="">
                        </div>
                        <!-- 属性 -->
                        <div class="d-flex flex-column bg-dark rounded flex-grow-1 text-light position-relative">
                            <!-- 第n条属性 -->
                            <div v-for="(val,key) in $root.getCampByIndex([matchInfo],matchInfo.tableid,0).attr" :key="key" class="d-flex justify-content-between position-relative line-bottom px-2 py-1">
                                <span class="fw-bold">{{key}}</span>
                                <div>{{val}}</div>
                            </div>
                            <div v-if="JSON.stringify($root.getCampByIndex([matchInfo],matchInfo.tableid,0).attr)=='{}'" class="position-absolute top-50 start-50 translate-middle d-flex flex-column align-items-center mt-2">
                                <img class="w-3rem" src="@/assets/images/common/data-null.png" alt="">
                                <span class="text-secondary fs-_8rem">暂无数据</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex flex-column overflow-hidden flex-grow-1 my-sm-2 rounded-3">
                    <!-- 支持方选择 -->
                    <div class="d-flex text-center ms--1_5rem me--1_5rem">
                        <div class="col bg-danger text-light fw-bold fs-5 skew-x--45 camp-hover-scale" :class="{'opacity-50':currCamp==2}" @click="currCamp=1">
                            <span class="d-block skew-x-45 py-2">支持红方</span>
                        </div>
                        <div class="col bg-primary text-light fw-bold fs-5 skew-x--45 camp-hover-scale" :class="{'opacity-50':currCamp==1}" @click="currCamp=2">
                            <span class="d-block skew-x-45 py-2">支持蓝方</span>
                        </div>
                    </div>
                    <!-- 数值选取区 -->
                    <div class="d-flex justify-content-between justify-content-sm-center p-1 p-sm-2" :class="{'bg-danger':currCamp===1,'bg-primary':currCamp===2}">
                        <!-- 数值显示 -->
                        <div class="flex-grow-1 flex-sm-grow-0 col-sm-3 d-flex pe-1 py-1">
                            <div class="flex-grow-1 d-flex flex-column rounded overflow-hidden" :class="{'btn-number-red':currCamp===1,'btn-number-blue':currCamp===2}">
                                <div class="d-flex fs-_8rem">
                                    <span class="px-1 bg-warning" style="background: linear-gradient(rgba(0,0,0,.2),rgba(255,255,255,.5),rgba(0,0,0,.2));">最高</span>
                                    <span class="flex-grow-1 text-center text-light" style="background: linear-gradient(rgba(0,0,0,.2),rgba(255,255,255,.2),rgba(0,0,0,.2));">{{ticketLimit.max}}</span>
                                </div>
                                <div class="flex-grow-1 d-flex justify-content-center align-items-center fs-3">
                                    <span :class="[(currTicket>ticketLimit.max||currTicket<ticketLimit.min)?'text-danger':'text-warning']" class="fw-bold text-shadow-white">{{ currTicket }}</span>
                                </div>
                                <div class="d-flex fs-_8rem">
                                    <span class="px-1 bg-warning" style="background: linear-gradient(rgba(0,0,0,.2),rgba(255,255,255,.5),rgba(0,0,0,.2));">最低</span>
                                    <span class="flex-grow-1 text-center text-light" style="background: linear-gradient(rgba(0,0,0,.2),rgba(255,255,255,.2),rgba(0,0,0,.2));">{{ticketLimit.min}}</span>
                                </div>
                            </div>
                        </div>
                        <!-- 数字按钮 -->
                        <div class="d-flex text-light fw-bold fs-5">
                            <div class="d-flex flex-column">
                                <div class="d-flex">
                                    <div :class="{'btn-number-red':currCamp===1,'btn-number-blue':currCamp===2}" class="rounded w-2_5rem h-2_5rem d-flex align-items-center justify-content-center m-1" @click="setCurrTicket(0)" role="button">0</div>
                                    <div :class="{'btn-number-red':currCamp===1,'btn-number-blue':currCamp===2}" class="rounded w-2_5rem h-2_5rem d-flex align-items-center justify-content-center m-1" @click="setCurrTicket(1)" role="button">1</div>
                                    <div :class="{'btn-number-red':currCamp===1,'btn-number-blue':currCamp===2}" class="rounded w-2_5rem h-2_5rem d-flex align-items-center justify-content-center m-1" @click="setCurrTicket(2)" role="button">2</div>
                                    <div :class="{'btn-number-red':currCamp===1,'btn-number-blue':currCamp===2}" class="rounded w-2_5rem h-2_5rem d-flex align-items-center justify-content-center m-1" @click="setCurrTicket(3)" role="button">3</div>
                                    <div :class="{'btn-number-red':currCamp===1,'btn-number-blue':currCamp===2}" class="rounded w-2_5rem h-2_5rem d-flex align-items-center justify-content-center m-1" @click="setCurrTicket(4)" role="button">4</div>
                                    <div :class="{'btn-number-red':currCamp===1,'btn-number-blue':currCamp===2}" class="rounded w-2_5rem h-2_5rem d-flex align-items-center justify-content-center m-1" @click="setCurrTicket(-1)" role="button">⇦</div>
                                </div>
                                <div class="d-flex">
                                    <div :class="{'btn-number-red':currCamp===1,'btn-number-blue':currCamp===2}" class="rounded w-2_5rem h-2_5rem d-flex align-items-center justify-content-center m-1" @click="setCurrTicket(5)" role="button">5</div>
                                    <div :class="{'btn-number-red':currCamp===1,'btn-number-blue':currCamp===2}" class="rounded w-2_5rem h-2_5rem d-flex align-items-center justify-content-center m-1" @click="setCurrTicket(6)" role="button">6</div>
                                    <div :class="{'btn-number-red':currCamp===1,'btn-number-blue':currCamp===2}" class="rounded w-2_5rem h-2_5rem d-flex align-items-center justify-content-center m-1" @click="setCurrTicket(7)" role="button">7</div>
                                    <div :class="{'btn-number-red':currCamp===1,'btn-number-blue':currCamp===2}" class="rounded w-2_5rem h-2_5rem d-flex align-items-center justify-content-center m-1" @click="setCurrTicket(8)" role="button">8</div>
                                    <div :class="{'btn-number-red':currCamp===1,'btn-number-blue':currCamp===2}" class="rounded w-2_5rem h-2_5rem d-flex align-items-center justify-content-center m-1" @click="setCurrTicket(9)" role="button">9</div>
                                    <div :class="{'btn-number-red':currCamp===1,'btn-number-blue':currCamp===2}" class="rounded w-2_5rem h-2_5rem d-flex align-items-center justify-content-center m-1" @click="setCurrTicket()" role="button">
                                        <i class="bi bi-trash d-flex"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex flex-column">
                                <div :class="{'btn-number-red':currCamp===1,'btn-number-blue':currCamp===2}" class="flex-grow-1 rounded w-2_5rem h-2_5rem d-flex align-items-center justify-content-center m-1 text-vertical" @click="setCurrTicket(Infinity)" role="button">最 大</div>
                            </div>
                            <div class="d-none d-sm-flex flex-column">
                                <div @click="subTicket(1)" class="btn-number-green bg-success flex-grow-1 rounded w-2_5rem h-2_5rem d-flex align-items-center justify-content-center m-1 text-vertical">投 票</div>
                            </div>
                        </div>
                    </div>
                    <!-- PC版竞猜单 -->
                    <div class="d-none d-sm-flex flex-column flex-grow-1">
                        <div class="d-flex flex-grow-1">
                            <div class="col me-1 d-flex flex-column">
                                <div class="border-start border-3 px-2 fw-bold text-light my-2 small">当前竞猜</div>
                                <div class="d-flex justify-content-start align-items-start text-center bg-dark bg-opacity-50 flex-grow-1 rounded-3 overflow-hidden text-nowrap position-relative">
                                    <div class="d-flex flex-column text-light">
                                        <span class="col bg-gradient px-1 fw-bold">阶段</span>
                                        <span v-if="getGuessLogByProg(true)" class="col bg-success bg-gradient">{{MATCH_PROG_STATE[getGuessLogByProg(true).progress]}}</span>
                                    </div>
                                    <div class="col d-flex flex-column bg-gradient">
                                        <span class="col text-danger text-shadow-white fw-bold">红(投票数/有效票)</span>
                                        <span v-if="getGuessLogByProg(true)" class="col text-light bg-danger bg-gradient">{{(getGuessLogByProg(true).red&&getGuessLogByProg(true).red[0])||0}} / {{(getGuessLogByProg(true).red&&getGuessLogByProg(true).red[1])||0}}</span>
                                    </div>
                                    <div class="col d-flex flex-column bg-gradient">
                                        <span class="col text-primary text-shadow-white fw-bold">蓝(投票数/有效票)</span>
                                        <span v-if="getGuessLogByProg(true)" class="col text-light bg-primary bg-gradient">{{(getGuessLogByProg(true).blue&&getGuessLogByProg(true).blue[0])||0}} / {{(getGuessLogByProg(true).blue&&getGuessLogByProg(true).blue[1])||0}}</span>
                                    </div>
                                    <div class="d-flex flex-column text-light">
                                        <span class="col bg-gradient px-1 fw-bold">操作</span>
                                        <div v-if="getGuessLogByProg(true)" class="col btn-warning d-flex text-light px-1" @click="subTicket(-1)">
                                            <span>点击撤票</span>
                                        </div>
                                    </div>
                                    <div v-if="!getGuessLogByProg(true)" class="position-absolute top-50 start-50 translate-middle d-flex flex-column align-items-center mt-2">
                                        <img class="w-3rem" src="@/assets/images/common/data-null.png" alt="">
                                        <span class="text-secondary fs-_8rem">暂无数据</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col ms-1 d-flex flex-column">
                                <div class="d-flex justify-content-between text-light my-2 small">
                                    <div class="border-start border-3 px-2 fw-bold">历史竞猜</div>
                                    <span v-if="matchInfo.state==3">总输赢：{{ Object.values(totalObj).reduce((prev,val)=>prev+val,0) }}</span>
                                </div>
                                <div class="d-flex justify-content-start align-items-start text-center bg-dark bg-opacity-50 flex-grow-1 h-0 rounded-3 text-nowrap overflow-y-scroll position-relative">
                                    <div class="d-flex flex-column text-light bg-opacity-75 opacity-75">
                                        <span class="col bg-gradient px-1 fw-bold">阶段</span>
                                        <template v-if="getGuessLogByProg().length>0">
                                            <span v-for="item in getGuessLogByProg()" :key="item" class="col bg-success bg-gradient">{{MATCH_PROG_STATE[item.progress]}}</span>
                                        </template>
                                    </div>
                                    <div class="col d-flex flex-column bg-gradient bg-opacity-75 opacity-75">
                                        <span class="col text-danger text-shadow-white fw-bold">红（投票数 / 有效票）</span>
                                        <template v-if="getGuessLogByProg().length>0">
                                            <span v-for="item in getGuessLogByProg()" :key="item" class="col text-light bg-danger bg-gradient">{{(item.red&&item.red[0])||0}} / {{(item.red&&item.red[1])||0}}</span>
                                        </template>
                                    </div>
                                    <div class="col d-flex flex-column bg-gradient bg-opacity-75 opacity-75">
                                        <span class="col text-primary text-shadow-white fw-bold">蓝（投票数 / 有效票）</span>
                                        <template v-if="getGuessLogByProg().length>0">
                                            <span v-for="item in getGuessLogByProg()" :key="item" class="col text-light bg-primary bg-gradient">{{(item.blue&&item.blue[0])||0}} / {{(item.blue&&item.blue[1])||0}}</span>
                                        </template>
                                    </div>
                                    <div class="d-flex flex-column text-light bg-opacity-75 opacity-75">
                                        <span class="col bg-gradient px-1 fw-bold">输赢</span>
                                        <span v-for="item in getGuessLogByProg()" :key="item" class="col bg-success bg-gradient">{{totalObj[item.progress]||0}}</span>
                                    </div>
                                    <div v-if="getGuessLogByProg().length<=0" class="position-absolute top-50 start-50 translate-middle d-flex flex-column align-items-center mt-2">
                                        <img class="w-3rem" src="@/assets/images/common/data-null.png" alt="">
                                        <span class="text-secondary fs-_8rem">暂无数据</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- PC版蓝方信息 -->
                <div class="d-none d-sm-flex col-2 p-2">
                    <div class="flex-grow-1 rounded-3 d-flex flex-column p-2 bg-primary bg-opacity-50 bg-gradient">
                        <div class="d-flex align-items-center pb-2 position-relative">
                            <!-- 头像 -->
                            <div class="rounded-circle overflow-hidden border border-primary border-2 w-3rem h-3rem">
                                <img class="w-100 h-100" :src="getPhotoByCamp(1)" @error="getDefaultImg(2,$event)" alt="">
                            </div>
                            <span class="text-primary text-shadow-white fw-bold ms-2">{{$root.getCampByIndex([matchInfo],matchInfo.tableid,1).name}}</span>
                            <img v-if="matchInfo.result==2" class="position-absolute top-50 start-50 ms-3 translate-middle-y w-7rem index-1" src="@/assets/images/room/guess/win_1.png" alt="">
                        </div>
                        <!-- 属性 -->
                        <div class="d-flex flex-column bg-dark rounded flex-grow-1 text-light position-relative">
                            <!-- 第n条属性 -->
                            <div v-for="(val,key) in $root.getCampByIndex([matchInfo],matchInfo.tableid,1).attr" :key="key" class="d-flex justify-content-between position-relative line-bottom px-2 py-1">
                                <span class="fw-bold">{{key}}</span>
                                <div>{{val}}</div>
                            </div>
                            <div v-if="JSON.stringify($root.getCampByIndex([matchInfo],matchInfo.tableid,1).attr)=='{}'" class="position-absolute top-50 start-50 translate-middle d-flex flex-column align-items-center mt-2">
                                <img class="w-3rem" src="@/assets/images/common/data-null.png" alt="">
                                <span class="text-secondary fs-_8rem">暂无数据</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 竞猜单 -->
            <div class="d-flex d-sm-none flex-column text-light p-2 flex-grow-1 h-0 overflow-y-scroll scroll-none" style="background: #001a57;">
                <div class="fw-bold text-center mb-1">我的竞猜单</div>
                <div class="d-flex flex-column">
                    <!-- 当前竞猜 -->
                    <div class="d-flex rounded overflow-hidden mb-2 border border-warning">
                        <div v-if="getGuessLogByProg(true)" class="text-warning text-vertical text-center fw-bold">{{MATCH_PROG_STATE[getGuessLogByProg(true).progress]}}</div>
                        <div class="d-flex flex-column flex-grow-1 text-center small">
                            <div class="d-flex text-warning bg-gradient">
                                <span class="col">支持方</span>
                                <span class="col">投票数</span>
                                <span class="col">有效票</span>
                            </div>
                            <div v-if="getGuessLogByProg(true)&&getGuessLogByProg(true).red" class="d-flex bg-danger bg-gradient">
                                <span class="col">红方</span>
                                <span class="col">{{getGuessLogByProg(true).red[0]}}</span>
                                <span class="col">{{getGuessLogByProg(true).red[1]}}</span>
                            </div>
                            <div v-if="getGuessLogByProg(true)&&getGuessLogByProg(true).blue" class="d-flex bg-primary bg-gradient">
                                <span class="col">蓝方</span>
                                <span class="col">{{getGuessLogByProg(true).blue[0]}}</span>
                                <span class="col">{{getGuessLogByProg(true).blue[1]}}</span>
                            </div>
                        </div>
                        <div v-if="getGuessLogByProg(true)" class="bg-warning text-center d-flex flex-column justify-content-center lh-1 px-1 hover-highlight" @click="subTicket(-1)" style="box-shadow: inset 0 0 .2rem .1rem #8d7700;">
                            <span>点击</span>
                            <span>撤票</span>
                        </div>
                    </div>
                    <!-- 历史竞猜 -->
                    <div class="d-flex rounded overflow-hidden mb-2 border border-secondary position-relative text-center small">
                        <div class="d-flex flex-column text-light bg-opacity-75 opacity-75">
                            <span class="col bg-gradient px-1 fw-bold">阶段</span>
                            <template v-if="getGuessLogByProg().length>0">
                                <span v-for="item in getGuessLogByProg()" :key="item" class="col bg-success bg-gradient">{{MATCH_PROG_STATE[item.progress]}}</span>
                            </template>
                        </div>
                        <div class="col d-flex flex-column bg-gradient bg-opacity-75 opacity-75">
                            <span class="col text-danger text-shadow-white fw-bold">红（投票数 / 有效票）</span>
                            <template v-if="getGuessLogByProg().length>0">
                                <span v-for="item in getGuessLogByProg()" :key="item" class="col text-light bg-danger bg-gradient">{{(item.red&&item.red[0])||0}} / {{(item.red&&item.red[1])||0}}</span>
                            </template>
                        </div>
                        <div class="col d-flex flex-column bg-gradient bg-opacity-75 opacity-75">
                            <span class="col text-primary text-shadow-white fw-bold">蓝（投票数 / 有效票）</span>
                            <template v-if="getGuessLogByProg().length>0">
                                <span v-for="item in getGuessLogByProg()" :key="item" class="col text-light bg-primary bg-gradient">{{(item.blue&&item.blue[0])||0}} / {{(item.blue&&item.blue[1])||0}}</span>
                            </template>
                        </div>
                        <div class="d-flex flex-column bg-gradient bg-opacity-75 opacity-75">
                            <span class="col bg-gradient px-1 fw-bold">输赢</span>
                            <span v-for="item in getGuessLogByProg()" :key="item" class="col bg-success bg-gradient">{{totalObj[item.progress]||0}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 按钮区 -->
            <div class="d-flex d-sm-none">
                <button class="btn btn-lg btn-success bg-gradient flex-grow-1" @click="subTicket(1)">投票</button>
            </div>
            <!-- 弹幕区 -->
            <!-- <div class="position-fixed bottom-0 start-0 pointer-events text-light index-1 w-75 h-25 d-flex mb-5 mb-sm-2">
                <div class="position-relative index-1">
                    <span class="bg-dark bg-opacity-75 p-2 text-vertical hover-highlight pointer-events-all" @click="isShowMsg=!isShowMsg">{{isShowMsg?'隐藏弹幕':'显示弹幕'}}</span>
                </div>
                <div class="overflow-hidden d-flex flex-column-reverse align-items-start position-relative transition-transform" :class="{'translate-0':isShowMsg,'translate-end':!isShowMsg}">
                    <div class="d-flex align-items-start m-1 p-1 bg-dark bg-opacity-50 rounded-3">
                        <span class="bg-info rounded-pill small text-nowrap px-1 me-1">如果有名称</span>
                        <span class="flex-grow-1 lh-sm">过了这村可就没这店了，别人坐等分钱，你还在犹豫不决！</span>
                    </div>
                    <div class="d-flex align-items-start m-1 p-1 bg-dark bg-opacity-50 rounded-3">
                        <span class="bg-info rounded-pill small text-nowrap px-1 me-1">如果有名称</span>
                        <span class="flex-grow-1 lh-sm">买定离手5</span>
                    </div>
                    <div class="d-flex align-items-start m-1 p-1 bg-dark bg-opacity-50 rounded-3">
                        <span class="bg-info rounded-pill small text-nowrap px-1 me-1">如果有名称</span>
                        <span class="flex-grow-1 lh-sm">买定离手4</span>
                    </div>
                    <div class="d-flex align-items-start m-1 p-1 bg-dark bg-opacity-50 rounded-3">
                        <span class="bg-info rounded-pill small text-nowrap px-1 me-1">如果有名称</span>
                        <span class="flex-grow-1 lh-sm">买定离手3</span>
                    </div>
                    <div class="d-flex align-items-start m-1 p-1 bg-dark bg-opacity-50 rounded-3">
                        <span class="bg-info rounded-pill small text-nowrap px-1 me-1">如果有名称</span>
                        <span class="flex-grow-1 lh-sm">买定离手2</span>
                    </div>
                    <div class="d-flex align-items-start m-1 p-1 bg-dark bg-opacity-50 rounded-3">
                        <span class="bg-info rounded-pill small text-nowrap px-1 me-1">如果有名称</span>
                        <span class="flex-grow-1 lh-sm">买定离手1</span>
                    </div>
                </div>
            </div> -->
            <!-- 换台区 -->
            <change-room :room-list="roomList" :count-list="countList" :pearl-obj="pearlObj"></change-room>
        </div>
        <!-- 侧边信息 -->
        <!-- <div class="d-flex flex-column">
            这里将要显示侧边信息
        </div> -->
    </div>
</template>
<script>
import { COMMAND, LAYER_TYPE,MATCH_PROG_STATE,MUTATION_TYPE,GAME_ID } from '@/assets/js/config';
import { getDeviceType } from '@/assets/js/common.js'
import mediaVideo from "@/components/public/video.vue";
import navbar from '@/components/public/navbar.vue';
import navbarVertical from '@/components/public/navbarVertical.vue';
import notice from '@/components/public/notice.vue';
import changeRoom from '@/components/public/changeRoom.vue'
import { useLayer } from '@/assets/js/useLayer';
export default {
    components:{
        mediaVideo,
        notice,
        navbar,
        changeRoom,
        navbarVertical
    },
    props: {
        hasChatMsg:false,//是否有未读的客服消息
        isPageReady:false,//页面是否加载完毕
        isFullscreen:{
            type:Boolean,
            default:false
        },//当前是否全屏
    },
    data() {
        return {
            MATCH_PROG_STATE,
            pearlObj: {
                id:0,//台面id
                pearl:[]//路单数据
            },//要重绘路单的对象
            countList:[],//路单统计列表
            videoList:[],//视频线路地址，当前支持最多两个
            currCamp:1,//1:红方，2:蓝方
            currTicket:0,//填写的票数
            ticketLimit:{
                min:0,
                max:0
            },//票数限制
            isShowMsg:true,//是否显示弹幕
            matchInfo:{
                camp:[],//阵营信息
                date:'',//赛事日期
                state:0,//赛事状态(1:预热中 2:比赛中 3:已结束)
                result:0,//赛事结果(0:未出结果 1:红方 2:蓝方)
                progress:[],//赛事阶段(1:闷盆 2:开盆 3:八扣 4:六扣 5:五扣 6:四扣 7:三扣)
                currProg:0,//当前阶段
            },//比赛信息
            guessLog:[],//竞猜记录
            isTicketing:false,//是否正在提交竞猜请求
            totalObj:{},//阶段输赢对象
        }
    },
    computed: {
        userInfo() {
            return this.$store.state.userInfo;
        },
        roomInfo() {
            return this.$store.state.roomInfo;
        },
        roomList(){
            return this.$store.state.roomList;
        },
        currVideoLine(){
			return this.$store.state.currVideoLine;
		},
    },
    mounted() {
        this.setWsMessage();
        //获取视频
        this.$root.wsSendJson({
            command:COMMAND.all_getvideo,
            tableId:this.roomInfo.id,
            lineId:this.currVideoLine,
            userid:this.userInfo.id,
            guid:this.userInfo.guid
        });
        this.refreshData();
        //获取竞猜限额
        this.$root.wsSendJson({
            command:COMMAND.all_getlimitredinfo,
            game:this.roomInfo.game,
            userid:this.userInfo.id,
            guid:this.userInfo.guid
        });
        //获取总输赢
        this.$root.wsSendJson({
            command:COMMAND.all_getgain,
            game:this.roomInfo.game,
            tableId:this.roomInfo.id,
            boot:this.roomInfo.boot,
            innings:this.roomInfo.innings,
            userid:this.userInfo.id,
            guid:this.userInfo.guid
        })
    },
    unmounted() {
        // removeEventListener("resize",this.setResize);
        delete this.$root.wsMsgObj["guess"];
    },
    methods: {
        /**
         * 刷新数据
         */
        refreshData(){
            //获取赛事信息
            this.$root.wsSendJson({
                command:COMMAND.guess_matchinfo,
                tableId:this.roomInfo.id,
                userid:this.userInfo.id,
                guid:this.userInfo.guid
            });
            this.getGuessLog();
        },
        /**
         * 获取竞猜记录
         */
        getGuessLog(){
            this.$root.wsSendJson({
                command:COMMAND.guess_getlog,
                tableid:this.roomInfo.id,
                userid:this.userInfo.id,
                guid:this.userInfo.guid
            });
        },
        setWsMessage(){
            this.$root.wsMsgObj["guess"]=(data)=>{
                switch (data.command) {
                    case COMMAND.all_getvideo:
                        let videoArr=data.video;
                        let list=[];//拼装好的视频地址数组
                        for (let i = 0; i < videoArr.length; i++) {
                            list.push(data.flvline+'/'+videoArr[i]+'.flv');
                        }
                        this.videoList=list;
                        break;
                    case COMMAND.guess_matchinfo:
                        if(data.tableid==this.roomInfo.id){
                            //更新比赛信息
                            this.matchInfo.camp=data.camp;
                            this.matchInfo.date=data.date;
                            this.matchInfo.state=data.state;
                            this.matchInfo.result=data.result;
                            this.matchInfo.progress=data.progress;
                            this.matchInfo.currProg=data.currProg;
                        }
                        break;
                    case COMMAND.all_gameresult:
                        this.refreshData();
                        break;
                    case COMMAND.all_getgain:
                        this.totalObj=data.total;
                        break;
                    case COMMAND.all_refresh:
                        //有列表并且列表中有需要校验数据的台(防止所在页面或者当前游戏没有列表导致调find报错或者推送的需要校验数据的台不可见导致后续执行报错)或者需要校验的台是当前所在台面
                        if((this.roomList&&typeof this.roomList.find(v=>v.id==data.id)!="undefined")||data.id==this.roomInfo.id){
                            if(data.game==GAME_ID.guess){//竞猜游戏则重新获取赛事信息
                                this.getGuessLog();
                            }
                        }
                        break;
                    case COMMAND.all_getroompearl:
                        this.pearlObj={
                            id:data.id,
                            pearl:data.pearl
                        }
                        this.countList[data.id]=data.count;
                        break;
                    case COMMAND.all_getlimitredinfo:
                        this.ticketLimit.min=data.limitred.range?data.limitred.range[0]:0;
                        this.ticketLimit.max=data.limitred.range?data.limitred.range[1]:0;
                        break;
                    case COMMAND.guess_getlog:
                        data.tableid==this.roomInfo.id&&(this.guessLog=data.list);
                        break;
                    case COMMAND.guess_subguess:
                        if(data.type==2){//撤票
                            if(data.result==1){
                                useLayer({str:"撤票成功！"});
                                // 修改余额
                                let currLog=this.getGuessLogByProg(true);
                                this.$store.commit({
                                    type:MUTATION_TYPE.setUserInfo,
                                    userInfo:{
                                        realCoin:this.$np.plus(this.userInfo.realCoin,(currLog.red?currLog.red[1]:0),(currLog.blue?currLog.blue[1]:0))
                                    }
                                });
                                this.guessLog.splice(this.guessLog.findIndex(v=>v.progress==this.matchInfo.currProg),1);//从竞猜记录中移除当前阶段记录

                            }else{
                                useLayer({str:"撤票失败！"});
                            }
                            this.isTicketing=false;
                        }else if(data.type==1){//投票
                            if(data.result==0){
                                useLayer({str:"投票失败！"});
                            }else if(data.result==1){
                                useLayer({str:"投票成功！"});
                                //修改余额
                                this.$store.commit({
                                    type:MUTATION_TYPE.setUserInfo,
                                    userInfo:{
                                        realCoin:this.$np.minus(this.userInfo.realCoin,this.currTicket) 
                                    }
                                });
                                //更新竞猜记录
                                let log = this.getGuessLogByProg(true);
                                if(log){//有记录则修改票数
                                    if(this.currCamp==1){
                                        if(log.red){
                                            log.red[0]+=this.currTicket;
                                            log.red[1]+=this.currTicket;
                                        }else{
                                            log.red=[0,0];
                                        }
                                    }else if(this.currCamp==2){
                                        if(log.blue){
                                            log.blue[0]+=this.currTicket;
                                            log.blue[1]+=this.currTicket;
                                        }else{
                                            log.blue=[0,0];
                                        }
                                    }
                                }else{//没有则直接加入
                                    log={
                                        progress:this.matchInfo.currProg,
                                        red:[this.currCamp==1?this.currTicket:0,this.currCamp==1?this.currTicket:0],
                                        blue:[this.currCamp==2?this.currTicket:0,this.currCamp==2?this.currTicket:0],
                                    };
                                    this.guessLog.push(log);
                                }
                                //设置提交列表
                                this.$store.commit({
                                    type:MUTATION_TYPE.setCurrBetList,
                                    room:{
                                        game:this.roomInfo.game,
                                        id:this.roomInfo.id,
                                        detail:JSON.parse(JSON.stringify(log)),
                                        winArr:[]
                                    }
                                });
                                //清空当前票数
                                this.currTicket=0;
                            }
                            this.isTicketing=false;
                        }
                        break;
                }
            }
        },
        /**
         * 根据阵营索引获取阵营头像
         * @param index 阵营索引
         */
        getPhotoByCamp(index){
            let photo=index==0?require('@/assets/images/home/red.jpg'):index==1?require('@/assets/images/home/blue.jpg'):"";
            if(this.matchInfo.camp&&this.matchInfo.camp.length>index){
                photo=this.matchInfo.camp[index].photo;
            }
            return photo;
        },
        /**
         * 获取竞猜记录
         * @param isCurr 是否当前阶段
         */
        getGuessLogByProg(isCurr){
            if(this.guessLog.length==0){
                return isCurr?null:[];
            }
            if(isCurr){
                return this.guessLog.find(v=>v.progress==this.matchInfo.currProg);
            }else{
                return this.guessLog.filter(v=>v.progress!=this.matchInfo.currProg).reverse();
            }
        },
        /**
         * 设置当前票数
         */
        setCurrTicket(number){
            let max=this.userInfo.realCoin<this.ticketLimit.max?this.userInfo.realCoin:this.ticketLimit.max;
            if(number===undefined){//清空
                this.currTicket=0;
            }else if(number===-1){//删除最后一位
                this.currTicket=Math.floor(this.currTicket/10);
            }else if(number===Infinity){//最大(只能在金币和票数允许范围内)
                this.currTicket=max;
            }else{
                //添加数字
                let newTicket=this.currTicket*10+number;
                this.currTicket=newTicket;
            }
        },
        /**
         * 投票/撤票
         */
        subTicket(type){
            if(this.isTicketing){
                useLayer({str:"请等待上一次操作完成！"});
                return;
            }
            if(type==-1){//撤票
                if(this.getGuessLogByProg(true)){//有投票
                    this.isTicketing=true;
                    useLayer({str:"是否确认撤销当前阶段所有投票？",type:LAYER_TYPE.confirm,btn:[this.$t("common.yes"),this.$t("common.no")],yesFn:(i)=>{
                        layer.close(i);
                        this.$root.wsSendJson({
                            command:COMMAND.guess_subguess,
                            tableid:this.roomInfo.id,
                            type:2,//1:投票 2:撤票
                            currProg:this.matchInfo.currProg,
                            loginType:this.userInfo.logintype,
                            userid:this.userInfo.id,
                            guid:this.userInfo.guid
                        });
                    },noFn:()=>{
                        this.isTicketing=false;
                    }});
                }
            }else if(type==1){//投票
                if(this.roomInfo.countdown<=0){
                    useLayer({str:"未到投票时间，无法投票！"});
                    return;
                }
                if(this.currTicket==0||this.currTicket<this.ticketLimit.min||this.currTicket>this.ticketLimit.max){
                    useLayer({str:`请输入正确的票数范围：${this.ticketLimit.min} - ${this.ticketLimit.max}`});
                    return;
                }
                if(this.currTicket>this.userInfo.realCoin){
                    useLayer({str:"您的金币不足投票！(1金币:1票)"});
                    return;
                }
                //当前已投票数加将投票数大于票数范围
                let log=this.getGuessLogByProg(true);
                if(log){
                    let alreadyTicket=0;//已投票数
                    if(this.currCamp==1){
                        alreadyTicket=log.red?log.red[0]:0;
                    }else if(this.currCamp==2){
                        alreadyTicket=log.blue?log.blue[0]:0;
                    }
                    if(alreadyTicket+this.currTicket>this.ticketLimit.max){
                        useLayer({str:`当前阶段您已投票${alreadyTicket}票，最多还能投${this.ticketLimit.max-alreadyTicket}票！`});
                        return;
                    }
                }
                this.isTicketing=true;
                useLayer({str:"是否给"+(this.currCamp==1?"红方":"蓝方")+"投"+this.currTicket+"票？",type:LAYER_TYPE.confirm,btn:[this.$t("common.yes"),this.$t("common.no")],yesFn:(i)=>{
                    layer.close(i);
                    this.$root.wsSendJson({
                        command:COMMAND.guess_subguess,
                        tableid:this.roomInfo.id,
                        type:1,//1:投票 2:撤票
                        camp:this.currCamp,
                        mode:1,//竞猜模式(1:胜出)
                        number:this.currTicket,
                        currProg:this.matchInfo.currProg,
                        loginType:getDeviceType(),
                        userid:this.userInfo.id,
                        guid:this.userInfo.guid
                    });
                },noFn:()=>{
                    this.isTicketing=false;
                }});

            }
        },
        /**
         * 获取默认图片
         */
        getDefaultImg(camp,event){
            //图片加载失败时显示默认图片
            event.target.src=location.origin+require('@/assets/images/home/'+(camp==1?'red':'blue')+'.jpg');
        }
    },
    watch:{
        //监听当前阶段变化
        "matchInfo.currProg"(newVal,oldVal){
            if(newVal!=oldVal){
                this.getGuessLog();
            }
        }
    }
}
</script>